<template>
  <main-layout>
    <template #nav>
      <div class="flex justify-between items-center">
        <router-link
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
          :to="{
            name: 'Home',
            query: {
              token: Jwt,
            },
          }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </router-link>
        <h1 class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">Product</h1>
        <router-link
          :to="{
            name: 'Basket',
            query: {
              token: Jwt,
            },
          }"
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-secondary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 11 4-7" /><path d="m19 11-4-7" /><path d="M2 11h20" /><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4" /><path d="m9 11 1 9" /><path d="M4.5 15.5h15" /><path d="m15 11-1 9" /></svg>
          <span class="sr-only">Total basket items</span>
          <div class="absolute inline-flex items-center justify-center h-4 w-4 font-bold text-primary-600 bg-secondary-600 rounded-md -top-1 -right-2" style="font-size: 8px;">{{ TotalBasketItems }}</div>
        </router-link>
      </div>
    </template>
    <div class="p-4">
      <slot v-if="isLoading">
        loading
      </slot>
      <slot v-if="!isLoading && product">
        <img
          :alt="product.name"
          class="h-auto max-w-full rounded-lg mb-4"
          :src="product.imageUrl"
          loading="lazy"
        />
        <p class="text-gray-500 font-semibold text-sm">{{ product.name }}</p>
        <p
          class="text-red-500 py-2 text-xs"
          v-if="product?.outOfStock"
        >
          Out of stock
        </p>
        <div class="mb-4 flex justify-between">
          <p class="text-gray-900 font-bold">{{ Currency }}{{ formatNumber(product.price) }}</p>
          <div class="flex justify-between items-center space-x-3" v-if="false">
            <button type="button" class="text-secondary-600 focus:ring-none focus:outline-none focus:ring-none font-medium rounded-full text-sm rounded-full text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[30px] h-[30px]">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <span class="sr-only">Icon description</span>
            </button>
            <div>{{basketQuantity}}</div>
            <button type="button" class="text-secondary-600 bg-primary-600 border focus:ring-none focus:outline-none focus:ring-none font-medium rounded-full text-sm p-1 rounded-full text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[18px] h-[18px]">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              <span class="sr-only">Icon description</span>
            </button>

          </div>
        </div>
        <div class="flex justify-between mb-4 items-center">
          <button
            @click="addToBasket"
            :disabled="isAddingToBasket"
            class="text-secondary-600 bg-primary-600 hover:bg-primary-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 w-full py-2.5 text-center disabled:bg-disabled-300 disabled:shadow-none disabled:ring-0 disabled:cursor-not-allowed disabled:bg-primary-500"
            type="button"
          >
            <span v-if="isAddingToBasket">
              <svg
                aria-hidden="true"
                role="status"
                class="inline w-4 h-4 mr-3 text-secondary-600 animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor" />
              </svg>
            </span>
            Add to basket
          </button>
        </div>
      </slot>
    </div>
  </main-layout>
</template>
<script setup>

import { useRoute, useRouter } from 'vue-router';
import {
  computed, onMounted, ref, watch,
} from 'vue';
import { useProductsStore } from '@/stores/products';
import { formatNumber } from '@/utils/general';
import { useBasketStore } from '@/stores/basket';
import { useAccountStore } from '@/stores/account';
import { useAnalytics } from '@/composables/analytics';
import { ANALYTICS_EVENT_NAMES } from '@/constants';

import MainLayout from '@/layouts/MainLayout.vue';

const route = useRoute();
const router = useRouter();

const BasketItems = computed(() => useBasketStore().Data);
const Currency = computed(() => useAccountStore().Currency);
const IsLoadingBasketItems = computed(() => useBasketStore().IsLoading);
const IsLoadingProducts = computed(() => useProductsStore().IsLoading);
const CustomerId = computed(() => useAccountStore().CustomerId);

const isLoading = computed(() => IsLoadingProducts.value
  || IsLoadingBasketItems.value);
const Products = computed(() => useProductsStore().Data);

const {
  Add: AddToBasket,
  Load: LoadBasket,
  SetData: SetBasketItems,
} = useBasketStore();
const {
  track,
} = useAnalytics();

const Jwt = computed(() => useAccountStore().Jwt);

const isAddingToBasket = ref(false);

const deliveryMethod = ref(null);
const paymentMethod = ref(null);
const noDeliveryMethodSelected = ref(false);
const noPaymentMethodSelected = ref(false);
const TotalBasketItems = computed(() => useBasketStore().TotalItems);

const productId = computed(() => route.params?.id);
const product = computed(() => (Products.value ?? [])
  .find((p) => p.id === productId.value));

// eslint-disable-next-line vue/max-len
const basketQuantity = computed(() => BasketItems.value.find((b) => b.product.id === productId.value)?.quantity ?? 0);

onMounted(() => {
  if (!productId.value) {
    router.push({
      name: 'Home',
      query: {
        token: Jwt.value,
      },
    });
  }
});

const addToBasket = async () => {
  track(ANALYTICS_EVENT_NAMES.ADD_PRODUCT_TO_BASKET, {
    productId: productId.value,
  });
  isAddingToBasket.value = true;
  const thisItem = BasketItems.value.find((item) => item.product.id === productId.value);
  const quantity = (thisItem?.quantity ?? 0) + 1;
  await AddToBasket({
    customerId: CustomerId.value,
    data: {
      quantity,
      productId: productId.value,
    },
  });
  if (thisItem) {
    const items = BasketItems.value
      .map((it) => (it.id === thisItem?.id ? {
        ...it,
        quantity,
      } : it));
    SetBasketItems(items);
  } else {
    await LoadBasket({
      setLoading: false,
    });
  }
  isAddingToBasket.value = false;
};

watch(deliveryMethod, (newV) => {
  if (newV) {
    noDeliveryMethodSelected.value = false;
  }
});

watch(paymentMethod, (newV) => {
  if (newV) {
    noPaymentMethodSelected.value = false;
  }
});
</script>
